module.exports = ({
    'SM810H005': 'Information',
    'SM810OTP001': '今後、このダイアログボックスを表示しない',
})